import React from "react";

const CocoHappy = () => (
  <svg width="112" height="94" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          d="M26.486 74.698c-2.64 6.228-7.082 6.666-9.675 9.87-3.107 3.838-3.85 10.377 1.227 15.679 5.077 5.303 20.423 3.764 20.423 3.764 8.793-18.696 6.731-30.877-11.975-29.313Z"
          fill="url(#c)"
        />
        <path
          d="M50.836 72.639c4.41-2.812 8.158 5.993 13.174 2.911 7.204-4.429 6.214-14.08 7.405-14.442 3.346-1.019 4.1 2.407 4.132 3.82.031 1.412-.006.583.046 1.33.027.381 3.426-3.274 5.355-3.21 1.928.064 8.547 4.599 8.023 12.452-.92 13.81-13.665 21.022-24.066 20.224C55.453 95 50.06 86.693 49.254 81.131c-.717-4.933-.305-7.289 1.582-8.492Z"
          fill="url(#d)"
        />
        <path
          d="M50.624 30.58c-1.68-.065-5.793.163-7.445.254 1.452.036 4.832-.028 6.662.125 9.682.808 10.181 11.033 10.181 11.033-.268-8.471-3.612-11.192-9.398-11.412Z"
          fill="url(#e)"
        />
        <path
          d="M23.319 72.103c-.02 4.887-4.271 26.183-2.784 28.262 2.84 3.97 25.078 3.576 30.77.022 4.09-2.556 3.28-23.457 3.273-27.914-.009-4.457-31.26-.37-31.26-.37Z"
          fill="url(#f)"
        />
        <path
          d="m23.657 36.928-2.417-3.62s-8.75 6.52-9.923 11.392c-.696 2.881 3.797 22.404 8.1 30.212 1.217 2.21 12.048 1.097 12.048 1.097l-7.808-39.081Z"
          fill="url(#g)"
        />
        <path
          d="M21.387 15.079c1.72 3.557 12.371 12.083 14.307 13.83-.437-.213-8.594-4.175-10.04-1.919-1.49 2.327-.848 5.894 2.098 6.954 2.947 1.06 14.008-1.219 14.008-1.219s-.186-.43-.539-1.167l.812-.179a18.554 18.554 0 0 0 2.773-2.837l.008-.012c2.51-3.152 5.35-8.664 2.104-15.193-.54-.63-1.619 1.47-2.795 4.468-1.446 3.684-3.039 8.718-3.94 11.681-.186-.35-.39-.73-.603-1.124l-.026-.045c-3.38-6.147-10.268-16.38-17.984-14.687-.514.22-.527.734-.183 1.449Z"
          fill="url(#h)"
        />
        <path
          d="M44.816 28.533c2.51-3.152 5.35-8.664 2.103-15.193-.538-.63-1.618 1.47-2.794 4.468 1.092-1.931 2.203-3.492 2.68-2.635 2.203 3.974-.614 10.582-1.99 13.36Z"
          fill="url(#i)"
        />
        <path
          d="M21.387 15.079c.134-.36.468-.62 1.052-.749 7.395-1.623 16.547 13.076 17.114 13.99-3.379-6.15-10.267-16.383-17.982-14.69-.515.22-.528.734-.184 1.449Z"
          fill="url(#j)"
        />
        <path
          d="M17.286 41.811c1.151 8.54 2.858 17.347 4.792 27.103a8.826 8.826 0 0 0 3.18 5.201 8.843 8.843 0 0 0 5.796 1.903c7.58-.259 14.98-1.147 22.945-2.113a7.6 7.6 0 0 0 4.616-2.325 7.584 7.584 0 0 0 2.057-4.738c.568-9.378.05-18.345-.858-26.883a10.153 10.153 0 0 0-3.218-6.406 10.174 10.174 0 0 0-6.65-2.688c-8.635-.196-16.534.207-24.92 1.113a8.75 8.75 0 0 0-5.946 3.285 8.73 8.73 0 0 0-1.794 6.548Z"
          fill="url(#k)"
        />
        <path
          d="M33.668 58.52c.31-1.922-1.6-3.828-4.267-4.259-2.667-.43-5.081.778-5.392 2.7-.311 1.92 1.6 3.828 4.267 4.258 2.667.43 5.081-.778 5.392-2.7ZM60.91 58.427a6.122 6.122 0 0 1-1.775 1.033c-2.405.919-4.892.26-5.555-1.472-.663-1.732.748-3.882 3.156-4.802 1.471-.562 2.972-.534 4.067-.03.065 1.74.1 3.498.106 5.27Z"
          fill="#5587F9"
        />
        <path
          d="M56.545 55.626c-5.163.739-9.892-2.49-10.54-7.199-.29-2.101.273-4.232 1.582-6.014 1.525-2.078 3.936-3.488 6.61-3.872 5.164-.74 9.893 2.491 10.541 7.2.29 2.095-.272 4.232-1.58 6.013-1.38 1.878-3.48 3.21-5.845 3.736-.253.054-.509.1-.768.136Zm-7.88-12.376c-1.091 1.486-1.561 3.255-1.323 4.983.545 3.955 4.591 6.655 9.02 6.022 2.325-.333 4.405-1.547 5.716-3.33 1.097-1.49 1.564-3.256 1.322-4.987-.544-3.954-4.59-6.655-9.02-6.022-.225.032-.45.073-.67.117-2.049.456-3.86 1.603-5.046 3.214v.003ZM31.954 56.82c-5.633.779-10.795-2.654-11.508-7.65-.318-2.225.292-4.49 1.718-6.379 1.662-2.203 4.29-3.697 7.21-4.101 5.631-.777 10.794 2.654 11.507 7.65.318 2.224-.292 4.49-1.718 6.378-1.502 1.992-3.792 3.404-6.372 3.956-.276.058-.555.107-.837.146Zm-8.637-13.164c-1.194 1.581-1.706 3.468-1.443 5.31.601 4.216 5.038 7.1 9.888 6.432 2.544-.35 4.824-1.643 6.258-3.544 1.193-1.581 1.705-3.467 1.442-5.31-.602-4.216-5.037-7.101-9.888-6.43-.248.033-.492.076-.735.128-2.25.48-4.237 1.698-5.522 3.414Z"
          fill="#FEE643"
        />
        <path
          d="M46.098 48.026a.694.694 0 0 0 .17-1.324c-.095-.04-2.368-.97-5.798.13a.694.694 0 1 0 .425 1.322c2.907-.934 4.819-.179 4.837-.172a.702.702 0 0 0 .366.044Z"
          fill="#FEE643"
        />
        <path
          d="M57.475 36.323a14.89 14.89 0 0 0-2.115-1.285 16.573 16.573 0 0 0-2.287-.957 14.565 14.565 0 0 0-2.46-.584 12.034 12.034 0 0 0-2.597-.049.972.972 0 0 0-.911 1.052.968.968 0 0 0 1.08.878.828.828 0 0 0 .109-.015l.03-.006a10.265 10.265 0 0 1 2.164-.224c.751.017 1.5.1 2.237.244.752.152 1.492.36 2.213.623.726.257 1.43.573 2.104.944l.02.01a.382.382 0 0 0 .415-.638l-.002.007ZM32.425 33.98a18.263 18.263 0 0 0-3.13.534c-1.01.258-1.996.601-2.948 1.026-.952.437-1.85.981-2.679 1.622a10.447 10.447 0 0 0-2.113 2.299.401.401 0 0 0 .632.492l.019-.02a9.477 9.477 0 0 1 2.133-1.823c.807-.48 1.666-.866 2.56-1.152a16.84 16.84 0 0 1 2.76-.6 16.507 16.507 0 0 1 2.77-.142h.032a1.122 1.122 0 0 0 1.17-1.067 1.119 1.119 0 0 0-1.206-1.169ZM51.047 49.4a.467.467 0 0 0-.423-.22.459.459 0 0 0-.361.693c.969 1.512 2.645 2.452 4.47 2.325 2.727-.198 4.772-2.724 4.557-5.628-.215-2.903-2.599-5.108-5.326-4.911-1.959.141-3.567 1.492-4.23 3.325a.459.459 0 0 0 .467.605.468.468 0 0 0 .4-.312c.55-1.489 1.85-2.58 3.434-2.696 2.221-.16 4.17 1.663 4.344 4.062.174 2.399-1.494 4.483-3.712 4.644-1.473.1-2.83-.662-3.62-1.888Z"
          fill="#1737AA"
        />
        <path
          d="M54.692 51.267c2.256-.163 3.944-2.237 3.77-4.632-.173-2.395-2.142-4.204-4.398-4.04-2.256.162-3.944 2.236-3.77 4.631.173 2.395 2.142 4.204 4.398 4.041Z"
          fill="#fff"
        />
        <path
          d="M57.106 47.294c.03-1.994-1.478-3.634-3.37-3.664-1.892-.029-3.451 1.564-3.482 3.558-.031 1.993 1.478 3.634 3.37 3.663 1.892.03 3.45-1.563 3.482-3.557ZM30.816 52.572c-2.499.05-4.577-2.014-4.627-4.6-.05-2.586 1.946-4.733 4.441-4.786a4.523 4.523 0 0 1 4.12 2.542.522.522 0 0 0 .48.294.496.496 0 0 0 .467-.695 5.56 5.56 0 0 0-5.086-3.13c-3.071.063-5.52 2.664-5.459 5.794.06 3.13 2.607 5.632 5.683 5.564A5.562 5.562 0 0 0 35.6 50.62c.176-.327-.092-.714-.476-.7a.526.526 0 0 0-.451.276 4.512 4.512 0 0 1-3.857 2.377Z"
          fill="#1737AA"
        />
        <path
          d="M35.292 47.903c.014-2.583-2.036-4.687-4.578-4.7-2.542-.013-4.613 2.07-4.627 4.652-.014 2.582 2.036 4.686 4.578 4.7 2.542.013 4.614-2.07 4.627-4.652Z"
          fill="#fff"
        />
        <path
          d="M30.335 51.883c2.047-.39 3.376-2.437 2.968-4.571-.407-2.134-2.398-3.547-4.445-3.157-2.047.39-3.377 2.437-2.968 4.571.407 2.134 2.398 3.547 4.445 3.157Z"
          fill="#1737AA"
        />
        <path
          d="M48.86 59.734c-.064.35-1.422.338-3.15.163-2.703-.277-6.31-.95-7.267-1.24-.317-.097-.116-.43-.015-.494 1.932-1.143 4.616-2.844 5.63-3.068a.752.752 0 0 1 .27-.01c.071.01.14.03.204.063 1.23.617 4.415 4.087 4.328 4.586ZM48.26 65.818c.101.444-1.584 6.386-4.985 6.73a3.277 3.277 0 0 1-1.325-.143c-4.234-1.321-6.12-7.27-6.135-7.54v-.008l6.238-.803s6.093 1.267 6.206 1.764Z"
          fill="#D6C14F"
        />
        <path
          d="M45.71 59.897c-2.703-.277-6.31-.95-7.267-1.24-.317-.097-.116-.43-.015-.494 1.932-1.143 4.616-2.844 5.63-3.068a.752.752 0 0 1 .27-.01c.14.317.226.655.253 1 .128 1.157.816 2.692 1.13 3.812ZM42.994 68.178c.27 1.29.327 2.802.28 4.37a3.277 3.277 0 0 1-1.324-.143c-4.234-1.321-6.12-7.27-6.135-7.54v-.008l4.424 2.262s2.312-1.068 2.755 1.059Z"
          fill="#FEE643"
        />
        <path
          d="M51.172 63.057c-.494 2.2-2.047 4.264-3.941 5.615-1.483 1.062-3.178 1.679-4.743 1.582-3.202-.198-6.695-2.161-7.923-5.333a6.451 6.451 0 0 1-.323-1.094c-.774-3.813 2.578-5.316 4.414-5.364 1.837-.047 4.478 1.058 7.406.905 4.218-.22 5.987-.229 5.11 3.69Z"
          fill="#1737AA"
        />
        <path
          d="M47.23 68.671c-1.482 1.063-3.178 1.68-4.743 1.582-3.201-.197-6.695-2.16-7.923-5.333 2.235-.817 5.293-1.123 8.657.276 1.978.82 3.24 2.086 4.009 3.475Z"
          fill="#DB6249"
        />
        <path
          d="M20.397 74.222c-5.267 3.98-13.025 22.844-13.09 28.273-.07 6.038 1.746 10.201 11.649 9.152 9.903-1.05 10.113-1.2 11.57-.551 1.458.649 4.156 2.296 5.558 1.623 1.403-.674 5.234-4.815 3.032-9.566 0 0 3.506 1.378 4.234-.5.203-.518-1.168-3.259-2.052-4.298-.855-1.004-1.066-1.504-6.759-2.754-5.016-1.101-7.83-.997-7.622-6.747.406-11.252-1.728-18.251-6.52-14.632Z"
          fill="url(#l)"
        />
        <path
          d="M27.176 91.767c-2.007 4.974-7.438 13.242-11.02 4.009 0 0-7.254 8.665-7.721 1.239.625-2.07 1.476-4.437 2.466-6.847.043 2.764 1.091 4.976 5.832-.777 0 0 4.897 10.624 10.23-3.609.007.983-.01 2.01-.048 3.073-.049 1.207.041 2.155.26 2.912ZM71.78 95.146c-2.247.55-4.567.746-6.875.584a16.398 16.398 0 0 1-3.589-.677c-2.922-1.844-3.966-5.067-.557-10.274 0 0-6.902-1.966-.656-8.899.853.323 1.732.449 2.652.214-1.373 2.306-2.153 5.28 2.347 5.915 0 0-4.282 12.556 6.678 13.137Z"
          fill="#A8C4F9"
        />
        <path
          d="m82.556 29.039-2.86.084a.668.668 0 0 1-.44-.238L77.97 26.35c-.22-.43-.715-.466-1.022-.198-.087.077-.137.198-.186.318l-.84 2.756a.352.352 0 0 1-.351.306l-2.8.42c-.127.032-.253.065-.34.141-.308.268-.34.763.056 1.04l2.337 1.616c.16.094.231.265.177.468l-.429 2.785c-.08.615.6.954 1.078.616l2.303-1.698c.132-.115.297-.103.5-.047l2.485 1.254c.236.183.533.08.708-.073.175-.153.318-.433.169-.692l-.9-2.714c-.072-.171.021-.33.114-.489l1.99-1.969c.4-.427.075-1.154-.463-1.151ZM86.966 21.693l-1.153 1.42a.427.427 0 0 1-.299.113l-1.762-.436a.413.413 0 0 0-.522.411c0 .075.039.149.076.223l.983 1.556a.225.225 0 0 1 .001.298l-.965 1.53c-.037.074-.074.149-.073.223.001.26.227.482.526.406l1.757-.456c.113-.038.225-.001.3.11l1.169 1.37c.264.295.712.107.747-.265l.14-1.823c0-.112.074-.186.186-.261l1.643-.679c.187-.038.261-.224.26-.373 0-.149-.077-.334-.264-.37l-1.689-.698c-.112-.036-.15-.147-.188-.259l-.123-1.784c-.04-.371-.527-.517-.75-.256Z"
          fill="#F9BF01"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="c"
        x1="29.313"
        y1="78.782"
        x2="28.113"
        y2="109.601"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1E5BF6" />
        <stop offset=".34" stopColor="#1D59F3" />
        <stop offset=".62" stopColor="#1B53E9" />
        <stop offset=".88" stopColor="#1648D8" />
        <stop offset=".93" stopColor="#1545D3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="79.384"
        y1="84.052"
        x2="51.367"
        y2="67.233"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5587F9" />
        <stop offset=".31" stopColor="#5284F9" />
        <stop offset=".55" stopColor="#487CF8" />
        <stop offset=".78" stopColor="#376EF7" />
        <stop offset=".99" stopColor="#1F5BF6" />
        <stop offset="1" stopColor="#1E5AF6" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="55.093"
        y1="30.963"
        x2="50.846"
        y2="37.963"
        gradientUnits="userSpaceOnUse">
        <stop offset=".01" stopColor="#D4E3FA" />
        <stop offset=".31" stopColor="#D4E3FA" />
        <stop offset=".4" stopColor="#BFD3F8" />
        <stop offset=".58" stopColor="#96B3F5" />
        <stop offset=".75" stopColor="#789BF3" />
        <stop offset=".9" stopColor="#668DF2" />
        <stop offset="1" stopColor="#5F88F1" />
      </linearGradient>
      <linearGradient
        id="f"
        x1="39.804"
        y1="75.113"
        x2="34.485"
        y2="109.49"
        gradientUnits="userSpaceOnUse">
        <stop offset=".05" stopColor="#1E5BF6" />
        <stop offset=".48" stopColor="#1D5AF4" />
        <stop offset=".68" stopColor="#1C55EC" />
        <stop offset=".84" stopColor="#184DE0" />
        <stop offset=".93" stopColor="#1545D3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1="16.942"
        y1="30.84"
        x2="23.927"
        y2="79.266"
        gradientUnits="userSpaceOnUse">
        <stop offset=".03" stopColor="#4675F3" />
        <stop offset=".18" stopColor="#3465EE" />
        <stop offset=".29" stopColor="#2C5DEC" />
        <stop offset=".71" stopColor="#2552DA" />
        <stop offset="1" stopColor="#2049CB" />
      </linearGradient>
      <linearGradient
        id="h"
        x1="41.829"
        y1="4.537"
        x2="24.346"
        y2="37.314"
        gradientUnits="userSpaceOnUse">
        <stop offset=".27" stopColor="#5F88F1" />
        <stop offset=".44" stopColor="#5B85F1" />
        <stop offset=".61" stopColor="#4F7BEF" />
        <stop offset=".78" stopColor="#3B6AED" />
        <stop offset=".88" stopColor="#2C5DEC" />
      </linearGradient>
      <linearGradient
        id="i"
        x1="49.022"
        y1="13.064"
        x2="41.466"
        y2="30.193"
        gradientUnits="userSpaceOnUse">
        <stop offset=".01" stopColor="#D4E3FA" />
        <stop offset=".26" stopColor="#D4E3FA" />
        <stop offset=".33" stopColor="#C7D9F9" />
        <stop offset=".64" stopColor="#8FADF5" />
        <stop offset=".87" stopColor="#6C92F2" />
        <stop offset="1" stopColor="#5F88F1" />
      </linearGradient>
      <linearGradient
        id="j"
        x1="-7550"
        y1="1694.64"
        x2="-7965.66"
        y2="4030.16"
        gradientUnits="userSpaceOnUse">
        <stop offset=".01" stopColor="#D4E3FA" />
        <stop offset=".31" stopColor="#D4E3FA" />
        <stop offset=".4" stopColor="#BFD3F8" />
        <stop offset=".58" stopColor="#96B3F5" />
        <stop offset=".75" stopColor="#789BF3" />
        <stop offset=".9" stopColor="#668DF2" />
        <stop offset="1" stopColor="#5F88F1" />
      </linearGradient>
      <linearGradient
        id="k"
        x1="47.266"
        y1="22.511"
        x2="32.218"
        y2="78.786"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5F88F1" />
        <stop offset=".26" stopColor="#4978F3" />
        <stop offset=".69" stopColor="#2A62F5" />
        <stop offset=".93" stopColor="#1E5AF6" />
      </linearGradient>
      <linearGradient
        id="l"
        x1="28.07"
        y1="108.29"
        x2="5.122"
        y2="73.124"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#5587F9" />
        <stop offset=".29" stopColor="#5284F9" />
        <stop offset=".52" stopColor="#487CF8" />
        <stop offset=".74" stopColor="#376EF7" />
        <stop offset=".94" stopColor="#1F5BF6" />
        <stop offset=".95" stopColor="#1E5AF6" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h111.316v94H0z" />
      </clipPath>
      <clipPath id="b">
        <path
          fill="#fff"
          transform="translate(0 6.185)"
          d="M0 0h112.553v87.816H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export { CocoHappy };
